export const APP_NAME = "Covivo";
export const APP_TAGLINE = "Menos burocracia, mais convivência";
